document.addEventListener('DOMContentLoaded', function () {
  const loadMoreButton = document.getElementById('load-more');

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function () {
      const currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
      const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
      const blogHandle = loadMoreButton.getAttribute('data-blog-handle');
      const nextPage = currentPage + 1;

      if (nextPage <= totalPages) {
        fetch(`/blogs/${blogHandle}?page=${nextPage}`)
          .then(response => response.text())
          .then(responseText => {
            const parser = new DOMParser();
            const responseDoc = parser.parseFromString(responseText, 'text/html');
            const newArticlesContainer = responseDoc.querySelector('#blog-articles');
            const newArticles = newArticlesContainer ? newArticlesContainer.children : [];

            Array.from(newArticles).forEach(article => {
              document.getElementById('blog-articles').appendChild(article);
            });

            loadMoreButton.setAttribute('data-current-page', nextPage);

            if (nextPage === totalPages) {
              loadMoreButton.style.display = 'none';
            }
          });
      }
    });
  }
});
